import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "testId"];
import React from 'react';
import { useFlexibleCardContext } from '../../../../../state/flexible-ui-context';
import { BaseTextElement } from '../common';
var CustomElementByAccessType = function CustomElementByAccessType(_ref) {
  var _context$data, _props;
  var className = _ref.className,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'custom-by-access-type-element' : _ref$testId,
    props = _objectWithoutProperties(_ref, _excluded);
  var context = useFlexibleCardContext();
  var accessType = context === null || context === void 0 || (_context$data = context.data) === null || _context$data === void 0 || (_context$data = _context$data.meta) === null || _context$data === void 0 ? void 0 : _context$data.accessType;
  var text = (_props = props[accessType]) !== null && _props !== void 0 ? _props : props.fallback;
  if (!text) {
    return null;
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    React.createElement(BaseTextElement, _extends({}, props, {
      content: text,
      className: className,
      testId: testId,
      hideFormat: true
    }))
  );
};
export default CustomElementByAccessType;